export default {
  404: "404",
register: "Registrar",
login: "Entrar",
profit: "Lucro",
payout: "Pagamento Alvo",
btnDouble: "2×",
wagered: "Apostado",
deposit: "Depósito",
inputFieldBtnMax: "Máx",
bets: "Apostas",
topHeaderAmount: "Valor",
resetPasswordTitle: "Redefinir Senha",
resetPasswordNewPasswordTitle: "Nova Senha",
resetPasswordNewPasswordErrorsRequired: "Senha é obrigatória.",
resetPasswordNewPasswordErrorsMinLength: "Mínimo de 8 caracteres.",
resetPasswordNewPasswordErrorsMaxLength: "Máximo de 16 caracteres.",
resetPasswordNewPasswordErrorsPattern:
  "Deve ter 8-16 caracteres, incluindo letras maiúsculas e minúsculas, números e um caractere especial (ex: NextGen@123)",
resetPasswordConfirmPasswordTitle: "Confirmar Senha",
resetPasswordConfirmPasswordErrorsNotMatched: "As senhas não coincidem.",
resetPasswordResetBtn: "Redefinir",
passwordResetSuccess: "Senha alterada",
resetPasswordWentWrong: "Algo deu errado!",
partners: "Parceiros",
submit: "Enviar",
signinUsername: "Email / Usuário",
signinForgetPassword: "Esqueceu a senha?",
signinErrorsUserNameRequired: "Por favor, insira usuário/email.",
signinErrorsPasswordRequired: "Senha é obrigatória.",
signinErrorsPasswordMinLength: "Mínimo de 8 caracteres.",
signinErrorsPasswordMaxLength: "Máximo de 16 caracteres.",
signinTryAgain: "Algo deu errado! Por favor, tente novamente.",
signinResetPasswordUsernameErr:
  "Por favor, insira usuário/email para redefinir a senha.",
signinResetMailSentSuccessContent:
  "Enviamos um link de redefinição de senha para seu e-mail. Por favor, verifique seu e-mail e redefina sua senha.",
signupTitle: "Registrar",
signupUsername: "Usuário",
signupEmail: "Email",
signupWalletConnect: "Entrar com Wallet",
signupPassword: "Senha",
signupErrorsUserNameRequired: "Por favor, insira usuário.",
signupErrorsFirstNameRequired: "Por favor, insira o primeiro nome.",
signupErrorsLastNameRequired: "Por favor, insira o sobrenome.",
signupErrorsUserNameMinLength: "Mínimo de {{minimumCharacters}} caracteres.",
signupErrorsUserNameMaxLength: "Máximo de {{maximumCharacters}} caracteres.",
signupErrorsUserNamePattern: "Por favor, use apenas letras e números.",
signupErrorsStringPattern: "Por favor, use apenas letras.",
signupErrorsEmailRequired: "Por favor, insira email.",
signupErrorsEmailPattern: "Por favor, insira um email válido.",
signupErrorsPasswordRequired: "Senha é obrigatória.",
signupErrorsPasswordMinLength: "Mínimo de 8 caracteres.",
signupErrorsPasswordMaxLength: "Máximo de 16 caracteres.",
signupErrorsPasswordPattern:
  "Deve ter 8-16 caracteres, incluindo letras maiúsculas e minúsculas, números e um caractere especial (ex: NextGen@123)",
otpIsRequired: "OTP é obrigatório",
otpMustBeSixDigits: "OTP deve ter 6 dígitos",
enterOtp: "Digite OTP",
accountMenuTransactions: "Transações",
accountMenuPromotions: "Promoções",
accountMenuProfile: "Perfil",
accountMenuLogout: "Sair",
accountMenuWithdraw: "Sacar",
pageNotFound: "Não conseguimos encontrar a página que você procura!",
error: "Erro",
somethingWentWrong: "Algo deu errado!",
verifyEmailThankYou: "Obrigado!",
verifyEmailEmailIsVerified: "Seu email foi verificado.",
verifyEmailWentWrong: "Algo deu errado!",
verifyEmailTokenExpired: "Email já verificado ou link expirado",
create: "Criar",
profilePassword: "Senha",
profileUploadProfile: "Enviar Foto",
profileErrorsEmailRequired: "Email é obrigatório.",
profileErrorsEmailPattern: "Por favor, insira um email válido.",
profileErrorsEmailMinLength: "Mínimo de 3 caracteres.",
profileErrorsEmailMaxLength: "Máximo de 20 caracteres.",
profileMessagesProfileUpdate: "Perfil atualizado",
profileMessagesChangePassword: "Senha atualizada",
profileProfilePicProfilePicUpload: "Enviar imagem de perfil",
profileNoNewChanges: "Não foi possível atualizar! Sem alterações novas.",
profileLoggedInWithSocial: "Você entrou com login social.",
profileSideNavigatorSound: "Som",
profileSideNavigatorMusic: "Música",
profileSideNavigatorProfile: "Meu Perfil",
profileSideNavigatorBetHistory: "Histórico de Apostas",
profileSideNavigatorTransactions: "Transações",
profileSideNavigatorDeposit: "Depósito",
withdraw: "Sacar",
profileSideNavigatorGameLimits: "Limites de Jogo",
profileSideNavigatorReferral: "Indicação",
profileSideNavigatorChangePassword: "Alterar Senha",
profileSideNavigatorTermsConditions: "Termos e Condições",
profileSideNavigatorLogOut: "Sair",
profileSideNavigatorProvablyFair: "Provavelmente Justo",
WalletInfoSectionNotAvailable: "Não Disponível",
WalletInfoSectionRealBalance: "Saldo Real",
GameLimitsMinimumBet: "Aposta mínima",
GameLimitsMaximumBet: "Aposta máxima",
GameLimitsMaxWinFor1Bet: "Ganho máximo por aposta",
ProvablyFairSubTitle:
  "Este jogo utiliza a tecnologia Provably Fair para determinar o resultado. Esta ferramenta permite alterar sua seed e verificar a justiça do jogo.",
ProvablyFairMaximumBet: "Aposta máxima:",
ProvablyFairMaxWinFor1Bet: "Ganho máximo por aposta",
promotionsTitle: "Promoções",
promotionsNoLosingData: "Desculpe, nenhuma promoção de bônus por perda disponível para ",
promotionsNoDepositData: "Desculpe, nenhuma promoção de bônus por depósito disponível para ",
promotionsCurrency: " moeda.",
promotionsViewBtn: "Ver",
promotionsClaimSuccess: "Você reivindicou com sucesso",
promotionsAvailability: "Disponibilidade: ",
promotionsAvailabilityTabLosing: "Bônus por perda",
promotionsAvailabilityTabDeposit: "Bônus de depósito",
promotionsDepositBonusTableCode: "Código",
promotionsDepositBonusTableMinDeposit: "Depósito Mín.",
promotionsDepositBonusTablePercentage: "Porcentagem",
promotionsDepositBonusTableMaxBonus: "Bônus Máx.",
promotionsDepositBonusTableRolloverMultipler: "Multiplicador de rollover",
promotionsDepositBonusTableMaxRolloverPerBet: "Rollover máximo por aposta",
promotionsDepositBonusTableTimeToAchieveRolloverTarget:
  "Tempo para atingir o alvo de rollover",
promotionsBonusCode: "CÓDIGO DE BÔNUS: ",
promotionsLossesClaim: "As perdas podem ser reclamadas (dentro do período da campanha): ",
promotionsLossesClaimLosingBonusTablePercentage: "Porcentagem",
promotionsLossesClaimLosingBonusTableMinLosingAmount: "Valor mínimo de perda",
promotionsBonusStatus: "Status do Bônus: ",
promotionsBonusAmount: "Valor do Bônus: ",
promotionsRolloverTarget: "Meta de Rollover: ",
promotionsRolloverAchieved: "Rollover atingido: ",
promotionsActivatebtn: "ATIVAR",
promotionsClaimBtn: "RECLAMAR",
promotionsCancelBtn: "CANCELAR",
promotionsBackBtn: "VOLTAR",
promotionsBonus: "Bônus",
promotionsTermAndConditions: " Termos & Condições",
promotionsClaimDepositBonusTitle: "Passos para reivindicar o bônus de depósito",
promotionsClaimDepositBonusFirst: "Ativar código de bônus",
promotionsClaimDepositBonusSecond: "Depositar valor na carteira",
promotionsClaimDepositBonusThird: "Alcançar meta de rollover para reivindicar o bônus",
promotionsClaimLosingBonusTitle: "Passos para reivindicar o bônus por perda",
promotionsClaimLosingBonusFirst: "Ativar código de bônus",
promotionsClaimLosingBonusSecond: "Jogue seus jogos favoritos",
promotionsClaimLosingBonusThird: "Clique em 'Reclamar perdas' para reivindicar perdas dentro do período da campanha",
promotionsWentWrong: "Algo deu errado!",
transactionTitle: "Transações",
transactionBetId: "ID da Aposta",
transactionUser: "Usuário",
transactionPayout: "Pagamento",
transactionAmount: "Valor",
transactionTime: "Data",
transactionProfit: "Lucro",
transactionCashout: "Saque",
transactionBet: "Aposta",
transactionMultix: "Multiplicador",
transactionWin: "Vitória",
transactionFairness: "Justiça",
transactionReferFriend: "Indicar um Amigo",
transactionTotal: "Total de Apostas",
transactionWins: "Vitórias",
transactionRefresh: "Atualizar",
transactionFilterTopMultipliers: "Principais Multiplicadores",
transactionFilterHugeWins: "Grandes Vitórias",
transactionFilterBiggestWins: "Maiores Vitórias",
transactionFilterMultipliers: "Multiplicadores",
transactionRealBalance: "Saldo Real",
depositWithdrawTXDate: "Data",
depositWithdrawTXAmount: "Valor",
depositWithdrawTXTxId: "TxID",
depositWithdrawTXTxType: "Tipo de Transação",
depositWithdrawTXStatus: "Status",
depositWithdrawTXNoData: "Nenhum dado disponível.",
depositTitle: "Depósito",
depositHistory: "Histórico",
depositSubTitle: "O usuário não pode depositar ou sacar moeda fiduciária. Por favor, contate o Admin para transacionar em moeda fiduciária.",
depositCopyNotSupported: "Seu navegador não suporta cópia automática para a área de transferência.\nPor favor, tente copiar o código manualmente.",
depositCopied: "Endereço copiado.",
withdrawNoBalance: "Saldo insuficiente.",
withdrawMinAmount: "Por favor, insira um valor maior ou igual a {{min}}.",
paginationNextBtn: "Próximo",
paginationPrevBtn: "Anterior",
LoginRequired: "Login obrigatório!",
betPlacedSuccessfully: "Aposta realizada",
betCancelledSuccessfully: "Aposta cancelada com sucesso",
PlayerEscapedSuccessfully: "Jogador saiu",
CopiedSuccessfull: "Copiado com sucesso",
usersConsent: "Ao acessar este site, confirmo que tenho 18 anos e revisei, \n compreendi e consenti com os",
termsOfService: "Termos de Serviço",
email: "Email",
playNow: "Jogar Agora",
orContinueWith: "Ou Continuar Com",
metamaskExtensionNotAvailable: "Por favor, instale a extensão MetaMask e atualize a página.",
cashier: "DEPÓSITO",
account: "CONTA",
hello: "Olá",
balance: "Saldo",
referrals: "Indicações",
settings: "Configurações",
withdrawals: "Saques",
demoWallet: "Carteira Demo",
wallet: "Carteira",
user: "Usuário",
amountIsRequired: "Valor é obrigatório",
minDepositAmount: "O valor do depósito deve ser maior que {{min}}.",
maxDepositAmount: "O valor do depósito deve ser menor que {{max}}.",
minWithdrawAmount: "Deve ser maior que {{min}}",
withdrawMustLessThanWallet: "O valor do saque deve ser menor que o saldo da sua carteira",
accountTypeIsRequired: "Tipo de conta é obrigatório.",
mobileNumberLength: "O número de celular deve ter {{length}} dígitos",
phoneIsRequired: "Telefone é obrigatório",
cpfError: "CPF deve ter {{length}} caracteres",
cpfRequiredError: "CPF é obrigatório",
cnpjError: "CNPJ deve ter {{length}} caracteres",
mainMenu: "MENU PRINCIPAL",
casino: "Cassino",
sports: "Esportes",
crypto: "Cripto",
NextGenXp: "NextGen XP",
playEarn: "Jogar & Ganhar",
NFT: "NFT",
poker: "Poker",
earnRewards: "GANHAR RECOMPENSAS",
rankUp: "Subir de Nível",
inviteFriends: "Convidar Amigos",
affiliates: "Afiliados",
sportsbook: "Casa de Apostas",
menu: "Menu",
allBets: "Todas as apostas",
highRollers: "Apostadores Altos",
luckyBets: "Apostas Sortudas",
trade: "Negociar",
player: "JOGADOR",
time: "TEMPO",
wager: "APOSTA",
payoutText: "PAGAMENTO",
bannerHeadOne: "Experimente a verdadeira inovação com o programa de",
bannerHeadTwo: "recompensas mais alto do setor.",
registerNow: "Registrar agora",
copy: "Copiar",
liveWins: "VITÓRIAS AO VIVO",
monthlyStatus: "M",
weeklyStatus: "S",
dailyStatus: "D",
nextEcosystem: "ecossistema NextGen",
allGames: "Todos os Jogos",
allSports: "Todos os Esportes",
cryptoFutures: "Futuros Cripto",
tradeNow: "Negociar Agora",
allTables: "Todas as Mesas",
nft: "NFT",
viewAll: "Ver Todos",
rewards: "Recompensas",
profile: "Perfil",
nextgenProfile: "PERFIL NEXTGEN",
totalBets: "Total de Apostas",
totalWagered: "Total Apostado",
joinDate: "Data de Entrada",
displaySocialLinks: "Exibir Contas Sociais Vinculadas",
privateProfile: "Perfil Privado",
rank: "Classificação",
nextRank: "Próximo Nível",
changeUsername: "Alterar usuário",
newPassword: "Nova senha",
repeatNewPassword: "Repita a nova senha",
changeName: "Alterar nome",
linkSocialAccount: "Vincular conta social",
privateProfileTooltip:
  "Uma vez definido como privado, outros usuários não poderão ver suas apostas, recompensas ou links sociais",
socialLinksTooltip:
  "Vincule suas contas sociais para que outros usuários possam segui-lo.",
balances: "Saldos",
createReferralBalance: "Criar saldo de indicação",
total: "Total",
tips: "Dicas",
receivedAmount: "Valor recebido",
dateOrTime: "Data/Hora",
view: "Ver",
allChains: "Todas as Chains",
creditAmount: "Valor de crédito",
setCustomReferralLink: "Definir link de indicação personalizado",
changeEmail: "Alterar email",
newEmail: "Novo email",
newUsername: "Novo usuário",
username: "Usuário",
changePassword: "Alterar senha",
twoFactorAuthentication: "Autenticação em dois fatores",
twoFactorAuthenticationTitle:
  "Recomendamos fortemente usar autenticação em dois fatores, pois protege sua conta com senha e telefone. Um email e senha devem ser configurados para ativar o 2FA. Enquanto o 2FA estiver ativado, você não poderá logar via Steam.",
enable2fa: "Ativar 2FA",
verifyIdentityByKyc: "Verifique sua identidade (KYC)",
oldPassword: "Senha antiga",
live: "Ao vivo",
soccer: "Futebol",
tennis: "Tênis",
fifa: "Fifa",
basketball: "Basquete",
iceHockey: "Hóquei no Gelo",
volleyball: "Vôlei",
tableTennis: "Tênis de Mesa",
baseball: "Beisebol",
golf: "Golfe",
boxing: "Boxe",
myBets: "Minhas Apostas",
favourites: "Favoritos",
americanFootball: "Futebol Americano",
buyCrypto: "Comprar Cripto",
oldEmail: "Email antigo",
loggedInSuccess: "Login concluído",
loggedOutSuccess: "Logout concluído",
signup: "Cadastro concluído",
tokenVerify: "Token de verificação enviado para seu email. Por favor, verifique",
emailVerify: "Email verificado",
emailChangedSuccess: "Email atualizado",
emailUpdateOtp: "OTP enviado para o novo email",
profileUpdatedSuccess: "Perfil atualizado",
otpVerified: "Senha única (OTP) verificada",
twoFADeactivated: "Autenticação em dois fatores desativada",
internalServerError: "Erro interno do servidor",
unAuthorized: "Não autorizado",
dataNotFound: "Dados não encontrados",
setReferralLink: "Definir link de indicação...",
notFound: "Não encontrado",
nextgenOriginals: "Melhores Jogos",
status: "Status",
success: "Sucesso",
failed: "Falhou",
pending: "Pendente",
date: "Data",
to: "Para",
roundId: "ID da Rodada",
bet: "Aposta",
win: "Vitória",
at: "em",
downloadAll: "Baixar Todos",
gameText: "Jogo",
searchGames: "Buscar jogos",
provider: "Fornecedor",
search: "Buscar",
all: "Todos",
sortBy: "Ordenar por",
popular: "Popular",
loadMore: "Carregar Mais",
bitcoin: "Bitcoin",
btc: "BTC",
chat: "Chat",
loginToChat: "Login para conversar",
send: "Enviar",
expand: "Expandir",
collapse: "Recolher",
emailPlaceholder: "seuemail@dominio.com",
removeFromFavourite: "Remover dos favoritos",
addToFavourite: "Adicionar aos favoritos",
verify: "Verificar",
accountVerification: "Verificação de conta",
recentlyPlayed: "Recentemente Jogados",
moreFrom: "Mais de",
demoMode: "Modo Demo",
providersList: "Lista de Fornecedores",
games: "Jogos",
providers: "Fornecedores",
close: "Fechar",
joinedOn: "Entrou em",
rewarded: "Recompensado",
saySomething: "Diga algo",
addressIsRequired: "Endereço é obrigatório",
withdrawRequestSent: "Solicitação de saque enviada. Aguardando aprovação.",
noMatchesFound: "Nenhum resultado encontrado",
tip: "Dica",
sendTip: "Enviar dica",
minAmount: "O valor deve ser maior que {{min}}",
maxAmount: "O valor deve ser menor que {{max}}",
doNotShowTip: "Não mostrar dica no chat",
demoAvailable: "Demo disponível",
denoNotAvailable: "Demo não disponível",
goFullscreen: "Tela cheia",
endsAt: "Termina em",
inProgress: "Em andamento",
eventEnd: "Fim do evento",
latestPromotions: "Últimas Promoções",
archived: "Arquivadas",
noPromotionsFound: "Nenhuma promoção encontrada",
claim: "Reivindicar",
add: "Adicionar",
viewDashboard: "Ver Dashboard",
prize: "Prêmio",
timeLeft: "Tempo restante",
viewTransactions: "Ver transações",
sendAmountInCashier:
  "Envie o valor de {{- currency}} de sua escolha para o seguinte endereço para receber o equivalente em Coins.",
yourPersonalDepositAddress: "Seu endereço pessoal de depósito {{- currency}}",
copyAddress: "Copiar endereço",
theValueOfCurrencyMayChange:
  "O valor de {{- currency}} pode variar entre agora e o momento em que recebermos seu pagamento",
doNotHaveAnyCurrency: "Não possui {{- currency}}?",
depositOptions: "Opções de Depósito",
withdrawalOptions: "Opções de Saque",
withdrawCurrency: "Sacar {{- currency}}",
enterAddressToReceiveFunds:
  "Por favor, insira o endereço da carteira {{- currency}} onde deseja receber os fundos. Após confirmação, o saque geralmente é processado em alguns minutos.",
receivingCurrencyAddress: "Endereço de recebimento {{- currency}}",
withdrawalAmount: "Valor do saque",
pasteYourCurrencyAddressHere: "Cole seu endereço de carteira {{- currency}} aqui...",
request: "Solicitar",
receiveTheSpecifiedAmount:
  "*Você receberá a quantidade especificada de {{- currency}} em seu endereço de saque",
valueMayVary:
  "*O valor subtraído do seu saldo pode variar entre agora e o processamento do saque",
coupons: "Cupons",
updateEmail: "Atualizar email",
update: "Atualizar",
loginHistory: "Histórico de login",
showLoginHistory: "Mostrar histórico de login",
wagerErr: "Valor da aposta é obrigatório",
minWagerErr: "Aposta mínima é 1",
mulValErr: "Multiplicador entre 1 - 1000",
closeBetErr: "Insira valor válido para fechar aposta",
profitErr: "Insira valor válido de lucro",
multiplierErr: "Multiplicador é obrigatório",
manual: "Manual",
auto: "Automático",
pnLFee: "Taxa PnL",
flatFee: "Taxa Fixa",
takeProfitLabel: "LUCRAR AO PREÇO",
closeBetLabel: "FECHAR APOSTA AO PREÇO",
priceUpLabel: "O PREÇO SUBIRÁ OU CAIRÁ?",
up: "Subir",
down: "Cair",
payoutMul: "MULTIPLICADOR DE PAGAMENTO",
safe: "Seguro",
wild: "Wild",
placeBet: "Fazer Aposta",
roundEnd: "A RODADA TERMINA EM",
timerInfo:
  "Todas as apostas Rollercoaster serão encerradas e o preço será redefinido para $1.000 todos os dias às 00:00 UTC",
month: "mês",
PNL: "PNL",
ROI: "ROI",
roi: "roi",
funding: "Financiamento/H",
exitPriceLabel: "Preço de Saída",
cashedOut: "Saque Realizado",
open: "Aberto",
chartPreferences: "Preferências do Gráfico",
yAxis: "Preferências do Eixo Y",
additionalFeatures: "Recursos Adicionais",
themes: "Temas",
locale: "Localidade",
changeTimezone: "Alterar Fuso Horário",
changeLanguage: "Alterar Idioma",
tooltip: "Tooltip",
field: "Campo",
value: "Valor",
dateTime: "Data/Hora",
winningAmount: "Valor Ganho",
activeBets: "Apostas Ativas",
closedBets: "Apostas Fechadas",
publicBets: "Apostas Públicas",
leaderboard: "Placar",
howToPlay: "Como Jogar",
rOICalculator: "Calculadora ROI",
allInstruments: "Todos os Instrumentos",
week: "Semana",
monthLabel: "Mês",
day: "Dia",
betLabel: "APOSTA",
entryPrice: "PREÇO DE ENTRADA",
bustPriceLabel: "Preço de Quebra",
multiplierLabel: "MULTIPLICADOR",
exitPrice: "PREÇO DE SAÍDA",
pnl: "P&L",
details: "Ver detalhes",
profitLoss: "Lucro & Perda",
noBalance: "Saldo insuficiente.",
maxBetAmount: "Valor máximo de aposta",
limit: "limite excedido.",
minBetAmount: "Valor mínimo de aposta",
rollsLimitMsg: "O número de rolls deve ser menor ou igual a 100.",
mines: "Minas",
loginFailed: "Falha no login",
noEntries: "Nenhuma entrada",
descriptionIsRequired: "Descrição é obrigatória",
description: "Descrição",
report: "Denunciar",
userReportedSuccessfully: "Usuário denunciado",
tipSendSuccessfully: "Dica enviada",
walletSettings: "Configurações da Carteira",
hideZero: "Ocultar saldos zerados",
hideZeroInfo: "Seu saldo zero não aparecerá na carteira",
displayFiat: "Exibir cripto em fiat",
displayFiatInfo:
  "Todas as apostas e transações serão liquidadas no equivalente em cripto",
noteForApprox: "Por favor, note que estes são valores aproximados.",
save: "Salvar",
limits: "Limites",
wagerLimit: "Limite de Aposta",
lossLimit: "Limite de Perda",
depositLimit: "Limite de Depósito",
takeABreak: "Fazer Pausa",
customTimePeriod: "Período Personalizado",
timePeriod: "Período",
selfExclusion: "Auto Exclusão",
confirm: "Confirmar",
setLimit: "Definir Limite",
removeLimit: "Remover Limite",
enterAmount: "Digite o Valor",
hours: "Horas",
daily: "Diário",
weekly: "Semanal",
monthly: "Mensal",
cancel: "Cancelar",
usedLimit: "Limite Usado",
type: "Tipo",
updatedAt: "Atualizado em",
editLimit: "Editar Limite",
limitRemovedMessage: "Seu Limite Seguinte Será Removido.",
setLimitMessage:
  "Você está prestes a definir o seguinte limite para sua conta. Observe que, caso queira alterar o limite, poderá fazê-lo após 24 horas.",
setBreakMessage:
  "Você está prestes a bloquear o acesso à sua conta por um período definido. Após usar esta opção, não poderá fazer login para alterar o período de bloqueio. Para escolher outro período ou estender o existente, entre em contato via suporte ao vivo.",
setSessionLimitMessage:
  "Você está prestes a definir o seguinte limite para sua conta. Caso queira alterá-lo, levará 24 horas para que o novo limite seja aplicado após definir outro valor.",
removeSessionLimitMessage: "Seu Limite de Sessão Será Removido",
notAchieved: "não atingido",
flexibleRegistration: "Registro Flexível!",
mostPlayed: "Mais Jogados",
badge: "Distintivos",
allBadges: "Todos os Distintivos",
socialMedia: "Mídias Sociais",
allLinks: "Todos os Links",
statistics: "Estatísticas",
newMessage: "Nova mensagem",
tipFor: "dica para",
play: "Jogar",
betOn: "Apostar em",
liveCasino: "Cassino Ao Vivo",
ecosystemUnbeatableOdds:
  "Aposte Melhor - Acesse odds imbatíveis em eventos emocionantes com nossa plataforma de apostas de primeira linha!",
startBetting: "Começar a Apostar",
ecosystemJoinTheFun: "Junte-se à Diversão - Explore jogos exclusivos do NextGen e mais de +9.000 favoritos de cassino!",
futures: "Futuros",
ecosystemTrade: "NGB é sua porta de entrada confiável para o futuro de jogos online imersivos e apostas!",
ecosystemCasino24x7: "Experimente a emoção do jogo em tempo real com dealers profissionais a qualquer hora e em qualquer lugar. Mergulhe na ação sem parar!",
joinNow: "Junte-se Agora",
noNotificationsFound: "Nenhuma notificação encontrada",
notifications: "Notificações",
lobby: "Lobby",
rollercoaster: "NextGen Coaster",
applyReferralCode: "Aplicar código de referência",
referralCode: "Código de referência",
referralLink: "Link de referência",
copyLink: "Copiar link",
referralLinkCopied: "Link de referência copiado",
withdrawAddressCannotBeSame:
  "O endereço de saque não pode ser o mesmo que o seu",
userId: "ID do Usuário",
active: "Ativo",
inactive: "Inativo",
currency: "Moeda",
hostGames: "Organize jogos,",
earnCrypto: "Ganhe cripto",
inviteHostAndEarn: "Convide, Organize & Ganhe - Realize seus próprios eventos NextGen",
startEarning: "Começar a Ganhar",
nextGen: "NextGen",
whitePaper: "Whitepaper",
deepDiveInto: "Mergulhe na Economia da Moeda NextGen",
learnMore: "Saiba Mais",
sport: "esporte",
vipRanked: "Vip classificado",
betMoreEarnMore: "Aposte Mais, Ganhe Mais - Maximize seu Potencial",
expiresAt: "Expira em",
upload: "Enviar",
pleaseSelectImage: "Por favor, selecione uma imagem",
imageSizeMustLessThan: "O tamanho da imagem deve ser menor que {{size}} mb",
imageSizeFormat: "Use formato de imagem png, jpeg, jpg.",
maxFileSize: "Tamanho máximo: 2 MB",
dragPosition: "Arraste para alterar posição",
onlyNumbers: "Apenas Números",
cannotBeRemoved: "Não pode ser removido",
amountInBetween: "O valor deve estar entre diário e mensal (inclusivo)",
amountEqualOrGreater: "Valor igual ou maior que semanal",
amountEqualOrLess: "Valor deve ser igual ou menor que semanal e mensal",
cannotBeIncreased: "Não pode ser aumentado",
enterPassword: "Digite a senha",
sessionLimit: "Limite de Sessão",
timePeriodRequired: "Período é obrigatório",
amountGTZero: "Valor maior que zero",
mma: "MMA",
counterStrike: "Counter Strike",
rugbyUnion: "Rugby Union",
valorant: "Valorant",
cricket: "Críquete",
dota: "DOTA-2",
rugbyLeague: "Rugby League",
hilo: "Hilo",
crash: "Crash",
cancelBetSuccessfully: "Aposta cancelada",
start: "Iniciar",
invalidBetAmount: "Valor da aposta inválido",
zeroError: "Deve ser maior que 0",
flipCoin: "Cara ou Coroa",
customs: "Personalizado",
redeemCode: "RESGATAR CUPOM",
couponText: "Nós postamos regularmente em nosso",
copyrightText:
  "<aLink>{{website}}</aLink> is owned by {{companyName}}, a Limited Company registered in Cyprus. License Registration Number {{licenseNumber}}.",
platform: "Plataforma",
support: "Suporte",
faq: "FAQ",
partnershipProgram: "Programa de Parceria",
blog: "Blog",
helpCenter: "Central de Ajuda",
aboutUs: "Sobre nós",
community: "Comunidade",
facebook: "Facebook",
twitter: "Twitter",
instagram: "Instagram",
discord: "Discord",
english: "Inglês",
hindi: "Hindi",
french: "Francês",
legal: "Legal",
cryptoTransactions: "Transações de Cripto",
sendersName: "Nome do remetente",
hideLoginHistory: "Ocultar histórico de login",
loginMethod: "Método de login",
deviceType: "Tipo de dispositivo",
ip: "IP",
tradingDefinition:
  "O trading de cripto não é considerado jogo, portanto não está coberto pela nossa licença de jogos.",
perks: "benefícios",
connected: "Conexão estabelecida",
twitch: "Twitch",
connect: "Conectar",
setUpGoogleAuthenticator: "CONFIGURAR GOOGLE AUTHENTICATOR",
twoFACode: "CÓDIGO 2FA",
downloadTheGoogleAuthenticator:
  "1. Baixe o aplicativo Google Authenticator para iPhone ou Android",
saveTheFollowingAccountToken:
  "2. Salve o seguinte Token da Conta (Chave) em um local seguro",
accountTokenKey: "Token da Conta (Chave)",
scanQRCodeWithApp: "3. Escaneie o QR Code com o app Google Authenticator",
enterTheTokenBelow: "4. Insira o Token abaixo",
copied: "Copiado",
code: "Código",
furtherVerificationRequired: "Verificação adicional necessária",
firstName: "Primeiro nome",
lastName: "Último nome",
dateOfBirth: "Data de nascimento",
year: "Ano",
addressLine: "Linha do endereço",
addressLineTwo: "Linha do endereço 2",
city: "Cidade",
province: "Província",
postalCode: "Código Postal",
country: "País",
submitInformation: "Enviar informações",
level: "Nível",
required: "Obrigatório",
rejected: "Rejeitado",
completed: "Concluído",
cancelled: "Cancelado",
onHold: "Em espera",
kycRequestSubmittedSuccessfully: "Solicitação KYC enviada",
reRequested: "Solicitado novamente",
cashBalance: "Saldo em dinheiro",
bonusBalance: "Saldo de bônus",
specialBonus: "Bônus Especial",
today: "Hoje",
noRewards: "Sem recompensas",
viewPendingRewards: "Ver recompensas pendentes",
totalClaimed: "Total resgatado",
pendingRewards: "Recompensas pendentes",
amount: "Valor",
others: "Outros",
createdAt: "Criado em",
horseRacing: "Corrida de Cavalos",
addToHomeScreen: "Adicionar NextGen à Tela Inicial",
oneTabAccess: "Acesso com 1 toque no seu celular",
install: "Instalar",
addToHome: "Adicionar à tela inicial",
inChromeSafari: "No Chrome/Safari, toque no",
buttonAndChoose: "botão e escolha",
afterCompletingThisStep:
  "Após concluir esta etapa, acesse NextGen Bets com um toque no seu celular!",
settlementId: "ID de liquidação",
commission: "Comissão",
totalCommission: "Comissão total",
commissionSettlement: "Liquidação de comissão",
startplaying: "Começar a jogar",
forgotPassword: "Esqueceu a senha",
resetPassword: "Redefinir senha",
locked: "Bloqueado",
unlocked: "Desbloqueado",
yourRank: "Sua classificação",
nextRanks: "Próximas classificações",
allRanks: "Todas as classificações",
bonusClaimedSuccessfully: "Bônus resgatado",
passwordUpdated: "Senha atualizada!",
thatsOkayItHappens:
  "Tudo bem. Acontece. Clique no botão abaixo para continuar. Email",
passwordsMustMatch: "As senhas devem coincidir",
youNearlyThere: "Quase lá!",
weSendYouVerificationEmail:
  "Enviamos um email de verificação. Verifique sua caixa de entrada e confirme sua conta.",
verifyEmailAddress: "Verificar endereço de email",
pleaseNoteThatTheLinkWillExpire:
  "Observe que este link expira em 5 dias. Se você não se cadastrou no NextGen Bets, ignore este email. Obrigado",
autoBetStops: "Apostas automáticas paradas devido ao limite de valor excedido",
casinoBets: "Apostas de cassino",
sportsBet: "Apostas esportivas",
cryptoTrades: "Trades de cripto",
customBets: "Apostas personalizadas",
nothingFound: "Nada encontrado",
bonus: "Bônus",
claimedAt: "Resgatado em",
available: "Disponível",
previous: "Anterior",
next: "Próximo",
tooManyRequests: "Muitas solicitações.",
limitUpdatedSuccessFully: "Limite atualizado",
youLost: "Você perdeu",
cashOutFailed: "Saque falhou",
betAlreadyPlaced: "Aposta já realizada",
betCashedOut: "Aposta sacada",
noFavouritesIn: "Sem favoritos em",
team: "Equipe NextGen",
fiatAmount: "Valor Fiat",
cryptoAmount: "Valor em Cripto",
moonpay: "Moonpay",
paymentMethod: "Método de pagamento",
transactionId: "ID da transação",
address: "Endereço",
comingSoon: "Em breve!",
minOneCharacterRequired: "Mínimo de um caractere",
verifyOtp: "Verificar OTP",
noResults: "Sem resultados",
moreFromBrand: "Mais do NextGen Bets",
cryptoDeposit: "Depósito em Cripto",
cryptoWithdraw: "Saque em Cripto",
fiatDeposit: "Depósito Fiat",
fiatWithdraw: "Saque Fiat",
goToPaymentsPage: "Ir para a página de pagamentos.",
bankTransfer: "Transferência bancária",
initiateTransfer: "Iniciar transferência",
emt: "EMT",
initiateEmt: "Iniciar EMT",
checkYourMailForFurtherDetails: "Verifique seu email para mais detalhes",
gigadet: "Gigadet",
wallet88: "Wallet88",
select_language:"Selecionar idioma",
raise_a_ticket:"Abrir um ticket"

}
